import { makeStyles } from 'tss-react/mui';

export const useStyles = () => {
  const styler = makeStyles();

  return styler(() => {
    return {
      appMenu: {
        width: '270px',
        marginBottom: '24px',
      },
    };
  })();
};
